export class BatteryFormatValueConverter {
	toView(value: number) {
		return `${(value / 1000).toFixed(2)} V`;
	}
}

export class BatteryPercentageValueConverter {
	toView(value: number) {
		return `${(value / 1000).toFixed(2)} V`;
	}
}